module.exports = __webpack_public_path__ + "img/vietnam.faa818be.svg";